import { getObjectUseCase, upsertUseCase } from "../../../usecases/object";
import BaseFormPresenter from "../../../base/BaseFormPresenter";
import { restUseCase } from "../../../usecases/rest";
import { getCurrentUserUseCase } from "../../../usecases/user";

class EmailBlastFormPresenter extends BaseFormPresenter {
  constructor(view) {
    super();
    this.view = view;
    this.getObjectUseCase = getObjectUseCase();
    this.upsertUseCase = upsertUseCase();
    this.getCurrentUserUseCase = getCurrentUserUseCase();
  }

  async getCurrentUser() {
    const user = await this.getCurrentUserUseCase.execute();
    this.currentUser = user;
    return user;
  }

  async getObject() {
    const collection = this.view.getCollectionName();
    const id = this.object.id || this.view.getObjectId();
    if (id) {
      const params = { include: ["client", "client.email_address"] };
      try {
        this.view.showProgress();
        this.object = await this.getObjectUseCase.execute(collection, id, {
          params,
        });
        this.view.hideProgress();
        this.view.setObject(this.object);
      } catch (error) {
        this.view.hideProgress();
        this.view.showError(error);
      }
    }
  }

  generateBody(body, client) {
    return `
        <html>
            <body style="font-family: Arial, sans-serif; color: #000;">
                <p>Dear ${client.name},</p>
                <p>${body}</p>
            </body>
        </html>
    `;
  }

  async save() {
    const collection = this.view.getCollectionName();
    const method = "POST";
    const path = "/send-email/a66266bc-0ea4-463d-b298-4c827b9cc829";
    const clients = this.change.client;

    if (this.object.id) {
      this.change.id = this.object.id;
    }
    console.log("Email sent", this.change);

    for (const client of clients) {
      console.log("client", client);
      const obj = {
        to: client.email_address,
        subject: this.change.subject,
        body: this.generateBody(this.change.body, client),
      };
      try {
        await restUseCase().execute(method, path, { body: obj });

        this.view.navigateBack();
        // this.change = {};
      } catch (error) {
        throw error; // rethrow the error to be caught by the caller
      }
    }
    await this.upsertUseCase.execute(collection, this.change);
  }

  async resend(objectId) {
    const collection = "emailBlast";
    const method = "POST";
    const path = "/send-email/a66266bc-0ea4-463d-b298-4c827b9cc829";

    try {
      this.view.showProgress();
      const params = { include: ["client"] };
      const object = await this.getObjectUseCase.execute(collection, objectId, {
        params,
      });
      this.view.hideProgress();

      const clients = Array.isArray(object.client)
        ? object.client
        : [object.client];

      for (const client of clients) {
        const subject = object.subject;
        const body = this.generateBody(object.body, client);

        const payload = {
          to: client.email_address,
          subject: subject,
          body: body,
        };

        await restUseCase().execute(method, path, { body: payload });
      }
      this.view.showSuccess("Email has been sent successfully");
    } catch (error) {
      this.view.hideProgress();
      this.view.showError(error);
      console.error("Resend failed", error);
    }
  }

  // async submit() {
  //     if (Object.values(this.change).length === 0) {
  //         this.view.showSuccessSnackbar("Successfully saved!");
  //         return;
  //     }
  //     try {
  //         this.view.submitting();
  //         await this.save();
  //         this.view.submissionSuccess();
  //         this.view.showSuccessSnackbar("Successfully saved!");
  //     } catch (error) {
  //         this.view.submissionError(error);
  //         this.view.showError(error);
  //     }
  // }
}

export default EmailBlastFormPresenter;
